import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getCollectionsHandler, { IUserCollection } from "./get-collections.handler";
import completeCollectionHandler from "./complete-collection.handler";

export interface ICollectionsState extends IRequestState {
    items: IUserCollection[];
};

const initialState: ICollectionsState = {
    items: [],

    loading: false,
    error: "",
};

const collectionsSlice = createSlice({
    name: 'collections',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<ICollectionsState>) => {
        getCollectionsHandler(builder);
        completeCollectionHandler(builder);
    },
});

export default collectionsSlice.reducer;